module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/emma-eade0144ccccffd1399a98758fd87773.mp3";